import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/providers/AuthProvider';

export type EntityType = 'candidate' | 'company' | 'job' | 'list' | 'query' | 'workforce';

interface UserFavorite {
	id: string;
	user_id: string;
	entity_type: EntityType;
	entity_id: string;
	created_at: string;
}

export function useUserFavorites(entityType?: EntityType) {
	const { user } = useAuth();
	const [favorites, setFavorites] = useState<Set<string>>(new Set());
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!user) {
			setFavorites(new Set());
			setLoading(false);
			return;
		}

		const fetchFavorites = async () => {
			try {
				setLoading(true);
				let query = supabase
					.from('user_favorite')
					.select('entity_id, entity_type')
					.eq('user_id', user.id);

				if (entityType)
					query = query.eq('entity_type', entityType);

				const { data, error } = await query;

				if (error)
					throw error;

				const favoriteIds = new Set(data?.map((fav: { entity_id: string }) => fav.entity_id) || []);
				setFavorites(favoriteIds);
			} catch (error) {
				console.error('Error fetching favorites:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchFavorites();
	}, [user, entityType]);

	return { favorites, loading };
}
